import { render, staticRenderFns } from "./PendingDetails.vue?vue&type=template&id=8948628a"
import script from "./PendingDetails.vue?vue&type=script&lang=js"
export * from "./PendingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports